import { BounceLoader } from 'react-spinners';
import colors from '../../styles/colors.module.css';

import styles from './styles.module.css';

interface Props {
  // eslint-disable-next-line react/require-default-props
  size?: number;
}

const DeafBibleIcon = ({ size = 150 }: Props): JSX.Element => {
  return (
    <>
      <div className={styles.bouncer} style={{ width: size, height: size }}>
        <BounceLoader size={size} color={colors.cinnabar} />
      </div>

      <div className={styles.deafBibleIcon} style={{ width: size / 2, height: size / 2 }}>
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 55 55"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xmlSpace="preserve"
          style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            strokeLinejoin: 'round',
            strokeMiterlimit: 1.41421,
          }}
        >
          <path
            d="M43.952,25.169c-0.374,0.106 -1.204,0.499 -1.682,0.8c-0.479,0.302 -0.469,0.517 -0.535,0.915c-0.066,0.399 -0.33,0.678 -0.513,1.172c-0.184,0.495 -0.299,1.163 -0.487,3.07c-0.189,1.91 -2.246,3.815 -2.504,4.508c-0.102,0.27 -0.204,0.779 -0.517,1.944c-0.314,1.162 -0.253,1.786 -0.253,1.786c-0.393,2.397 -7.376,3.131 -7.59,2.091c-0.788,-3.86 -1.788,-3.589 -2.117,-5.605c-0.026,-0.166 -0.236,-0.763 -0.26,-0.929c-0.026,0.166 -0.236,0.763 -0.262,0.929c-0.327,2.016 -1.329,1.745 -2.117,5.605c-0.214,1.04 -7.195,0.306 -7.59,-2.092c0,0 0.061,-0.623 -0.253,-1.787c-0.311,-1.163 -0.415,-1.672 -0.517,-1.942c-0.258,-0.693 -2.315,-2.6 -2.504,-4.508c-0.187,-1.907 -0.303,-2.575 -0.486,-3.07c-0.184,-0.496 -0.446,-0.773 -0.512,-1.174c-0.068,-0.396 -0.058,-0.611 -0.536,-0.913c-0.479,-0.303 -1.5,-0.692 -1.873,-0.798c-0.374,-0.106 -0.676,-0.628 -0.527,-1.087c0.213,-0.647 1.006,-1.017 2.631,-0.836c0.818,0.091 1.511,0.427 1.988,0.814c0.478,0.386 0.616,0.845 0.717,1.228c0.011,-0.155 0.736,-3.291 0.851,-3.74c0.117,-0.455 1.308,-4.036 1.478,-4.625c0.172,-0.589 0.66,-1.859 0.809,-2.266c0.289,-0.785 1.899,-0.953 2.114,0.326c0.143,-0.602 0.398,-1.892 1.292,-2.056c0.897,-0.165 1.761,0.186 1.736,1.6c0.508,-0.255 1.64,-0.081 1.736,1c0.053,0.59 -0.058,1.27 -0.111,1.858c-0.045,0.493 -0.14,0.923 -0.185,1.235c0.396,-0.27 1.56,-0.238 1.576,1.033c0,0 0.069,1.718 -0.059,2.967c-0.094,0.922 0.015,1.185 0.142,2.158c0.03,0.229 0.399,1.408 0.462,1.629c0.062,-0.221 0.432,-1.4 0.46,-1.629c0.127,-0.973 0.236,-1.236 0.142,-2.158c-0.128,-1.249 -0.059,-2.967 -0.059,-2.967c0.016,-1.271 1.18,-1.303 1.578,-1.033c-0.045,-0.312 -0.14,-0.742 -0.185,-1.235c-0.055,-0.588 -0.166,-1.268 -0.113,-1.858c0.098,-1.081 1.228,-1.255 1.736,-1c-0.023,-1.414 0.841,-1.765 1.736,-1.6c0.896,0.164 1.151,1.454 1.292,2.058c0.217,-1.279 1.825,-1.113 2.116,-0.328c0.149,0.407 0.635,1.677 0.807,2.266c0.172,0.589 1.361,4.172 1.478,4.627c0.115,0.447 0.839,3.583 0.851,3.738c0.103,-0.383 0.239,-0.84 0.717,-1.228c0.479,-0.387 1.172,-0.723 1.99,-0.814c1.623,-0.181 2.225,0.187 2.436,0.835c0.151,0.458 -0.15,0.981 -0.524,1.086"
            style={{ fillRule: 'nonzero' }}
          />
        </svg>
      </div>
    </>
  );
};

export default DeafBibleIcon;
